import { useEffect, useState } from 'react'

export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number): ((...args: Parameters<F>) => void) => {
   let timeout: ReturnType<typeof setTimeout> | null = null

   return (...args: Parameters<F>): void => {
      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(() => func(...args), waitFor)
   }
}

/** Trails `value` by `delayMs` of quiet. */
export const useDebouncedValue =<T,>(value: T, delayMs: number): T => {
   const [debounced, setDebounced] = useState<T>(value)

   useEffect(() => {
      const timeout = setTimeout(() => setDebounced(value), delayMs)
      return () => clearTimeout(timeout)
   }, [value, delayMs])

   return debounced
}
